import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Print from 'vue-print-nb'
import NProgress from 'nprogress'


import '@/assets/fonts/font.css'
import '@/assets/icon/iconfont.css'
import 'nprogress/nprogress.css' // 引入默认样式

// 预载方正姚体：该字体仅在打印样式中使用，页面屏幕不会触发下载，
// 导致打印预览时字体不生效，这里主动触发字体加载
if (document.fonts && document.fonts.load) {
  document.fonts
    .load('14px "FangZhengYaoTI"', "方正姚体打印预载")
    .catch(() => {});
}


// 引入路由器
import router from "./router"
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 自定义指令
import '@/directives/tooltip'
import '@/directives/auth'
import '@/directives/excelFill'

Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(Print)
Vue.config.productionTip = false

import RightClickMenu from '@/components/RightClickMenu.vue'
Vue.component('RightClickMenu', RightClickMenu)

import { getHashParam, removeTicketParam } from '@/utils/pathUtil'
import { getTokenByTicket } from '@/api/ssoLogin'
import { handleTicketFallback } from '@/utils/ssoFallback'

// 配置 NProgress（自定义样式/行为）
NProgress.configure({
  showSpinner: false, // 隐藏转圈加载图标（SSO 登录不需要）
  speed: 300, // 动画速度
  trickleSpeed: 100, // 进度条缓慢前进速度
  minimum: 0.1 // 最小进度（避免直接从0开始）
})
// 暂未使用
// NProgress.start()

// 获取 URL 参数中的 token
let ticket = getHashParam("ticket");
if (ticket) {
  // 保存 token 到本地
  localStorage.setItem("ticket", ticket);
  // 清除 URL 中的 token 参数（优化体验）
  removeTicketParam()
  // 定义换取 token 的接口函数
  const fetchTokenFunc = (ticket) => {
    return getTokenByTicket({ticket});
  };
  // 调用兜底处理函数
  handleTicketFallback(
    ticket,
    fetchTokenFunc
  ).then(() => {
    console.log('--------------请求成功')
  }).catch(err => {
    console.error('SSO 登录兜底处理失败:', err);
  });
  // 立即标记「开始处理SSO回调」，暂时阻止路由守卫的跳转
  router.$isSSOCallbackHandled();
}

new Vue({
  render: h => h(App),
  router: router,
  store: store,
}).$mount('#app')

